import React from 'react';

export enum TagVariant {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum TagSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

interface TagProps {
  children: React.ReactNode;
  variant?: TagVariant;
  size?: TagSize;
  className?: string;
}

const variantClasses = {
  default: 'text-gray-700 border-gray-300',
  primary: 'text-blue-700 border-blue-300 bg-blue-50',
  secondary: 'text-purple-700 border-purple-300 bg-purple-50',
  success: 'text-green-700 border-green-300 bg-green-50',
  warning: 'text-yellow-700 border-yellow-300 bg-yellow-50',
  error: 'text-red-700 border-red-300 bg-red-50',
};

const sizeClasses = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-3 py-1.5 text-sm',
  lg: 'px-4 py-2 text-base',
};

const TagComponent: React.FC<TagProps> = ({children, variant = TagVariant.Default, size = TagSize.MD, className = ''}) => {
  const classes = ['inline-flex items-center font-medium border rounded-full', variantClasses[variant], sizeClasses[size], className]
    .filter(Boolean)
    .join(' ');

  return <span className={classes}>{children}</span>;
};

export const Tag = React.memo(TagComponent);
